import { BooleanInput, Create, CreateContextProvider, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useNotify, useRedirect, useRefresh, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import ErrorPage403 from 'src/pages/error/403';
import CustomTagInput from 'src/pages/admin/components/CustomTagInput';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TokenMetadataForm from './TokenMetadataForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateMetadata = ({ onClose }: { onClose: () => void }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useCreateController({
        resource: Resources.tokenMetadata,
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.tokenMetadata.createSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    case 'TOKEN_METADATA_ALREADY_EXISTS':
                        notify(t('module.tokenMetadata.validate.conflict'), { type: 'error' });
                        break;
                    default:
                        notify(t('module.tokenMetadata.unknownError'), { type: 'error' });
                        break;
                }
            }
        }
    });


    return (
        <CreateContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t("module.tokenMetadata.createToken")}</DialogTitle>
                <DialogContent>
                    <TokenMetadataForm isCreate />
                </DialogContent>
                <DialogActions>
                    <MUIButton variant="outlined" onClick={onClose}>
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="token-metadatas" action="create">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </CreateContextProvider>
    );
};

export default CreateMetadata;
